import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../../colorVars';
import { Body3 } from '../../../../../../atomic/text/Text';

export const CandleTriggerDetailsComponent = observer(({ details }) => {
  return (
    <td>
      <Body3 color={colors.lightGrey} fontWeight={500}>
        {details.breakPrice}
      </Body3>
    </td>
  );
});

CandleTriggerDetailsComponent.propTypes = {
  details: PropTypes.shape({
    breakPrice: PropTypes.any,
  }),
};
